import { makeStyles } from "@mui/styles";

import { appColors } from "src/consts/app-config";
import theme from "src/theme";

export const useStyles = makeStyles({
    selectWrapper: {
        position: "relative",
        borderRadius: 4,

        width: "100%",
        height: 48,

        cursor: "pointer",

        display: "flex",
        alignItems: "center",
        "&.prolimit": {
            opacity: 0,
            transition: "opacity ease-in 0.5s",
        },
    },
    "selectWrapper-primary": {
        background: "#F5F5F51A",
        border: "1px solid #FFFFFF4D",
    },
    "selectWrapper-secondary": {
        background: "transparent",
        border: "1px solid #FFFFFF4D",
    },
    selectedOptionWrapper: {
        display: "flex",
        alignItems: "center",
    },
    expandIcon: {
        color: appColors.white,
        transition: "0.3s ease",
        "&.isRotate": {
            transform: "rotate(180deg)",
        },
    },
    selectedValue: {
        width: "100%",
        height: "100%",
        padding: "0 15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        [theme.breakpoints.down(1800)]: {
            padding: "0 8px",
        },
        [theme.breakpoints.down(1800)]: {
            padding: "0 6px",
        },
    },
    selectedValueLabel: {
        fontSize: 16,
        fontWeight: 700,
        color: appColors.white,
        "&.hasIcon": {
            marginLeft: 5,
        },
    },
    selectDropdownWrapper: {
        display: "none",
        position: "absolute",
        width: "100%",
        zIndex: 100,
        background: "#000",
        borderRadius: 8,
        // overflow: "hidden",
        cursor: "pointer",
        height: "fit-content",
        maxHeight: "50dvh",
        overflow: "scroll",
        "-ms-overflow-style": "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
            width: "0!important",
        },
        "&.isOpen": {
            display: "block",
        },
        "&.top": {
            left: 0,
            bottom: "110%",
        },
        "&.bottom": {
            left: 0,
            top: "110%",
        },
    },
    "selectDropdownWrapper-primary": {
        filter: "drop-shadow(0px 0px 5px #000000)",
        border: "1px solid rgba(255, 255, 255, 0.3)",
        boxShadow: "rgb(0 0 0 / 20%) 0px 4px 4px inset",
    },
    selectOption: {
        display: "flex",
        alignItems: "center",
        color: "rgba(245, 245, 245, 0.9)",
        "&.isSelected": {
            color: "rgba(245, 245, 245, 0.9)",
            background: "rgba(105, 114, 128, 0.1)",
        },
    },
    selectOptionDefaultStyles: {
        padding: "10px 0 10px 15px",
    },
    selectOptionLabel: {
        fontWeight: 600,
        "&.hasIcon": {
            marginLeft: 5,
        },
    },
});
